module.exports = "/assets/0413ca7ab270c79aeca844ac10893c3b.jpg";